import CustomAccordion from '../CustomAccordion/CustomAccordion';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { CareInputSelector, resetCareInput, setAddress, setBirthday, setBrokersTakeCare, setCareClientName, setCareInput, setCareInputExpand, setCareYear, setCity, setCompanyAnniversary, setCountry, setFuneral, setHobby, setMidAutumn, setNewBaby, setNewYear, setPhone, setPicbirthday, setPicname, setPromotion, setSelectedCareId, setSex, setTriggerFocusCompanyNameInput, setWomenDay } from './reducers/CareInputReducer';
import CareApi from './api/CareApi';
import CareModel from './models/CareModel';
import { contactInputSelector } from '../Contact/reducers/ContactInputReducer';
import { CountryModel } from '../Contact/models/ContactStaticResourcesModel';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';
import TagsFilter from '../TagFilter/TagsFilter';
import { setUserDisplayNames, userSelectorSelector } from '../UserSelector/reducers/UserSelectorReducer';
import { QueryItem } from '../Tonnage/models/TonnageQueryModel';
import UserApi from '../UserManagement/api/UserApi';
import UserDisplayNameModel from '../UserSelector/models/UserDisplayNameModel';
import NumberFormatCustom from '../NumberFormatCustom/NumberFormatCustom';
import { Grid, Button, Autocomplete, TextField, AutocompleteChangeDetails, FormControl, RadioGroup, FormControlLabel, Radio, Tooltip } from '@mui/material';
import { CareSearchSelector, setTriggerCareSearch } from './reducers/CareSearchReducer';

const CareInput: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const careInputViewData = useSelector(CareInputSelector);
    const contactInputViewData = useSelector(contactInputSelector);
    const userSelectorData = useSelector(userSelectorSelector);
    const careSearchData = useSelector(CareSearchSelector);

    useEffect(() => {
        if (userSelectorData.userDisplayNames.length === 0) {
            UserApi.GetDisplayNames()
                .then((response: BaseResponse<UserDisplayNameModel[]>) => {
                    if (response.success) {
                        dispatch(setUserDisplayNames(response.data))
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                }).catch((error) => {
                    Utility.Alert.Error(error);
                })
        }
    }, [])

    useEffect(() => {
        if (careInputViewData.triggerSave > 0) {
            save();
        }
    }, [careInputViewData.triggerSave]);

    useEffect(() => {
        if (careInputViewData.triggerRefreshInput > 0) {
            refreshInput();
        }
    }, [careInputViewData.triggerRefreshInput]);

    const refreshInput = () => {
        dispatch(resetCareInput());
        dispatch(setSelectedCareId(""));
        dispatch(setTriggerFocusCompanyNameInput((new Date()).getTime()));
    }

    const getBrokersTakeCare = () => {
        if (!careInputViewData.input.brokersTakeCare || careInputViewData.input.brokersTakeCare.length == 0) {
            return [] as QueryItem[];
        }

        let results = [] as QueryItem[];
        let brokers = careInputViewData.input.brokersTakeCare.split(",");

        _.each(userSelectorData.userDisplayNames, (item) => {
            if (brokers.indexOf(item.id.toString()) > -1) {
                results.push({
                    id: item.id.toString(),
                    value: item.displayName,
                    positive: true
                } as QueryItem)
            }
        });

        return results;
    }

    useEffect(() => {
        if (careInputViewData.selectedClientId.length > 0) {
            selectCareById(careInputViewData.selectedCareId, careInputViewData.selectedClientId);
        }
    }, [careInputViewData.selectedCareId, careInputViewData.selectedClientId])

    const getCountry = () => {
        let country = _.find(contactInputViewData.staticResources.countries, (country) => {
            return country.code === careInputViewData.input.country
        })

        return country ? country : null;
    }

    const selectCareById = (careId: string, clientId: string) => {
        dispatch(showLoading(true));
        CareApi.GetById({
            clientId: clientId,
            careId: careId,
            year: careInputViewData.input.year
        }).then((response: BaseResponse<CareModel>) => {
            if (response.success) {
                if (response.data == null) {
                    dispatch(setCareInput({
                        clientId: careInputViewData.selectedClientId,
                        careId: careInputViewData.selectedCareId,
                        clientName: careInputViewData.input.clientName,
                        year: careSearchData.query.year
                    } as CareModel));

                } else {
                    dispatch(setCareInput(response.data));
                    dispatch(setCareYear(careSearchData.query.year));
                    dispatch(setCareClientName(careInputViewData.input.clientName));
                }

                dispatch(showLoading(false));

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    };

    const save = () => {
        try {
            validate();

            CareApi.Save(careInputViewData.input)
                .then((response: BaseResponse<CareModel>) => {
                    if (response.success) {
                        if (careInputViewData.input.clientId.length === 0) {
                            Utility.Alert.Success("Care added successful");
                        } else {
                            Utility.Alert.Success("Care updated successful");
                        }

                        refreshInput();

                        dispatch(setTriggerCareSearch((new Date()).getTime()));
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            Utility.Alert.Error(error);
        }
    }

    const validate = () => {
        if (careInputViewData.input.clientId.length === 0) {
            throw "You must select care to edit";
        }
    }

    return (
        <>
            {
                <CustomAccordion
                    title="Input"
                    defaultOpen={true}
                    className="top-quick-input"
                    open={careInputViewData.CareInputExpand}
                    onOpenChange={(isOpen: boolean) => {
                        dispatch(setCareInputExpand(isOpen));
                    }}
                >
                    <Grid container>
                        <Grid item lg={3} xs={12}>
                            <Grid container className='cargo-input-component'>
                                <Grid xs={10} lg={9}>
                                    <span>{careInputViewData.input.clientName}</span>
                                </Grid>
                                <Grid item xs={2} lg={3}>
                                    <Tooltip title="Reset (Alt + R)">
                                        <Button
                                            className="clear-input-button"
                                            tabIndex={-1}
                                            color="success"
                                            variant="contained"
                                            onClick={() => {
                                                refreshInput();
                                            }}
                                        >
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Autocomplete
                                className='cargo-input-component'
                                options={contactInputViewData.staticResources.countries}
                                getOptionLabel={(option: CountryModel) => {
                                    return option.name + "(" + option.code + ")"
                                }}
                                renderInput={(params) => <TextField {...params} label="Country" />}
                                value={getCountry()}
                                onChange={(event: React.SyntheticEvent, value: CountryModel | null, reason: string, details?: AutocompleteChangeDetails<CountryModel> | undefined) => {
                                    dispatch(setCountry(value ? value.code : ""));
                                }}
                            />
                            <TextField
                                className='cargo-input-component'
                                fullWidth
                                label="City"
                                value={careInputViewData.input.city}
                                onChange={(event) => {
                                    dispatch(setCity(event.target.value));
                                }}
                            >
                            </TextField>
                            <TextField
                                className='cargo-input-component'
                                fullWidth
                                label="Address"
                                value={careInputViewData.input.address}
                                onChange={(event) => {
                                    dispatch(setAddress(event.target.value));
                                }}
                            >
                            </TextField>
                            <TextField
                                className='cargo-input-component'
                                fullWidth
                                label="PIC Name"
                                value={careInputViewData.input.picname}
                                onChange={(event) => {
                                    dispatch(setPicname(event.target.value));
                                }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item lg={3} xs={12}>
                            <Grid container>
                                <Grid item xs={2} className='care-sex-label'>Sex</Grid>
                                <Grid item xs={10}>
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            value={careInputViewData.input.sex == null? "unknown": careInputViewData.input.sex? "male" : "female"}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                dispatch(setSex(event.target.value == "male"))
                                            }}
                                        >
                                            <FormControlLabel value="male" control={<Radio />} label="Male" />
                                            <FormControlLabel value="female" control={<Radio />} label="Female" />
                                            <FormControlLabel value="unknown" control={<Radio />} label="Unknown" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <StartEndDatepicker
                                startDateLabel="D.O.B"
                                className="cargo-input-component"
                                useSingleMode={true}
                                useQuickEndDateInput={false}
                                onStartDateChange={(date: string) => {
                                    dispatch(setPicbirthday(date));
                                }}
                                startDateValue={Utility.DateFormat.formatDateString(careInputViewData.input.picBirthday).toUpperCase()}
                                allowFreeInput={true}
                            >
                            </StartEndDatepicker>
                            <TextField
                                className='cargo-input-component'
                                fullWidth
                                label="Phone"
                                value={careInputViewData.input.phone}
                                onChange={(event) => {
                                    dispatch(setPhone(event.target.value));
                                }}
                            >
                            </TextField>
                            <TextField
                                className='cargo-input-component'
                                fullWidth
                                label="Hobby"
                                value={careInputViewData.input.hobby}
                                onChange={(event) => {
                                    dispatch(setHobby(event.target.value));
                                }}
                            >
                            </TextField>
                            <TagsFilter
                                data={_.map(userSelectorData.userDisplayNames, (item) => {
                                    return {
                                        id: item.id.toString(),
                                        value: item.displayName,
                                        positive: true
                                    } as QueryItem
                                })}
                                useFreeText={true}
                                label="Brokers"
                                className="fixture-search-item"
                                hideReverseButton={true}
                                value={getBrokersTakeCare()}
                                onValueChange={(value: QueryItem[]) => {
                                    let brokers = "";
                                    _.each(value, (item) => {
                                        brokers += item.id + ",";
                                    })

                                    dispatch(setBrokersTakeCare(brokers))
                                }}
                            ></TagsFilter>
                        </Grid>
                        <Grid item lg={3} xs={12}>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="New Year"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.newYear ? careInputViewData.input.newYear : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setNewYear(value));
                                }}
                            >
                            </TextField>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Mid Autumn"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.midAutumn ? careInputViewData.input.midAutumn : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setMidAutumn(value));
                                }}
                            >
                            </TextField>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Company Anniversary"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.companyAnniversary ? careInputViewData.input.companyAnniversary : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setCompanyAnniversary(value));
                                }}
                            >
                            </TextField>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Birthday"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.birthday ? careInputViewData.input.birthday : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setBirthday(value));
                                }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Promotion"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.promotion ? careInputViewData.input.promotion : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setPromotion(value));
                                }}
                            >
                            </TextField>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Women Day"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.womenDay ? careInputViewData.input.womenDay : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setWomenDay(value));
                                }}
                            >
                            </TextField>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="New Baby"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.newBaby ? careInputViewData.input.newBaby : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setNewBaby(value));
                                }}
                            >
                            </TextField>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Funeral"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={careInputViewData.input.funeral ? careInputViewData.input.funeral : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setFuneral(value));
                                }}
                            >
                            </TextField>
                        </Grid>

                        <Grid item lg={1} xs={12}>
                            <Tooltip title="Alt + S">
                                <Button
                                    onClick={save}
                                    variant="outlined"
                                >
                                    Save (s)
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </CustomAccordion>
            }
        </>
    )
};

export default CareInput;